/* eslint-disable indent */
/* global $ instantsearch */
import { renderEmpty, renderPerson, renderProject, renderVoice } from './templates';
import { focusTrap } from '../../utils';

class GlobalSearchOverlay {
  constructor(searchClient, locale) {
    this.$body = $('body');
    this.locale = locale;
    this.$window = $(window);
    this.$searchNavTrigger = $('#js-trigger-search-overlay');
    this.$overlay = $('.js-search-overlay');
    this.focusTrapCleanup = null;

    this.search = instantsearch({
      indexName: 'prod_global',
      searchClient,
    });

    this.init();
  }

  init() {
    this.$body.addClass('js-search-overlay-active');
    this.$window.on('keydown.overlay', evt => this.escOverlay(evt));
    this.$window.on('click.overlay', evt => this.onOutsideClick(evt));
    this.focusTrapCleanup = focusTrap(this.$overlay, this.$searchNavTrigger);
    this.addWidgets();
    this.search.start();
    this.focusSearch();
  }

  addWidgets() {
    let placeholder = this.locale === 'zh' ? '搜索' : 'Search Sasaki';
    this.search.addWidget(
      instantsearch.widgets.searchBox({
        container: '#overlay-searchbox',
        placeholder: placeholder,
        autofocus: true,
        templates: {
          submit: 'Submit search query',
          reset: 'Reset search query',
        },
      }),
    );

    this.search.addWidget(instantsearch.widgets.configure({ hitsPerPage: 24 }));

    const customHits = instantsearch.connectors.connectHits(this.renderGlobalHits.bind(this));
    this.search.addWidget(customHits({
      container: $('#overlay-hits'),
      transformItems: items => items.map(item => ({
        ...item,
        locale: this.locale
      })),
    }));
  }

  renderGlobalHits({ hits, results, widgetParams }) {
    let search_url   = this.locale === 'zh' ? '/zh/search/' : '/search/';
    let search_label = this.locale === 'zh' ? '查看结果' : 'View all results';

    if (results && hits.length === 0) {
      $(widgetParams.container).html(renderEmpty(results.query));
      return;
    }

    $(widgetParams.container).html(
      `${hits
        .map(item => {
          switch (item.content) {
            case 'Project':
              return renderProject(item, instantsearch);
            case 'Page':
              return renderProject(item, instantsearch);
            case 'Project Type':
              return renderProject(item, instantsearch);
            case 'Person':
              return renderPerson(item, instantsearch);
            case 'Voices':
              return renderVoice(item, instantsearch);
          }
        })
        .join('')}
        <p class="search-overlay__view-all">
          <a href="${search_url}?query=${results && hits.length ? results.query : ''}" class="search-overlay__view-all-link">${search_label}</a>
        </p>`,
    );
  }

  focusSearch() {
    $('#overlay-searchbox')
      .find('.ais-SearchBox-input')
      .focus();
  }

  resetSearch() {
    $('#overlay-searchbox')
      .find('.ais-SearchBox-reset')
      .click();
  }

  escOverlay(evt) {
    if (evt.which === 27) {
      evt.preventDefault();
      this.deinit();
    }
  }

  onOutsideClick(evt) {
    if (evt.target === this.$searchNavTrigger.get(0)) {
      return;
    }

    const clickedOverlay =
      evt.target === this.$overlay || $.contains(this.$overlay.get(0), evt.target);

    if (!clickedOverlay) {
      this.deinit();
    }
  }

  deinit() {
    this.$body.removeClass('js-search-overlay-active');
    this.resetSearch();
    this.$window.off('keydown.overlay');
    this.$window.off('click.overlay');

    if (this.focusTrapCleanup) {
      this.focusTrapCleanup();
    }
  }
}

export default GlobalSearchOverlay;
